import React from "react";
import { Modal, Button } from "react-bootstrap";
import useTranslation from "../../hooks/useTranslation";

const SessionExpiredPopup = ({ show, onClose }) => {
  const { t } = useTranslation("loginRelatedPages");

  return (
    <Modal show={show} onHide={onClose} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("sessionExpiredModalTitle")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t("sessionExpiredModalContent")}</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClose}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionExpiredPopup;
